
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Alerts_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 31.39 42.52","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Alerts_svg__st0",attrs:{"d":"M14.18 32.27c0-.45.15-.83.43-1.13.29-.3.65-.45 1.08-.45.43 0 .79.15 1.08.45.29.3.43.68.43 1.13 0 .44-.15.81-.43 1.12-.29.3-.65.45-1.08.45-.43 0-.79-.15-1.08-.45-.29-.31-.43-.68-.43-1.12m2.77-10.05l-.09 2.27-.36 5.21h-1.64l-.36-5.21-.09-2.27h2.54zM6.45 33.43c-.73 1.38-.05 2.51 1.51 2.51h15.45c1.57 0 2.24-1.12 1.51-2.51L17 18.42c-.73-1.39-1.91-1.39-2.65 0l-7.9 15.01zm8.96-23.23H4.1v1h11.32v-1zm0-2.9H4.1v1h11.32v-1zm0-2.9H4.1v1h11.32v-1zm14.56 36.7H1.42V1.42h16.62v12.44h11.93V41.1zm-.88-28.66h-9.64V2.51l9.64 9.93zm2.3 30.08V12.77L19 0H0v42.52h31.39z"}})])
          )
        }
      }
    